import types from './types';

const calculateChemRiskLevel = chemRiskLevelRequestDto => ({
  type: types.CALCULATE_CHEM_RISK_LEVEL,
  params: { chemRiskLevelRequestDto }
});

const calculateEnvRisk = envRiskRequestDto => ({
  type: types.CALCULATE_ENV_RISK,
  params: { envRiskRequestDto }
});

//Risk calculations
export const envRiskCalculation = () => ({ type: types.ENV_RISK_CALCULATION });
export const chemRiskCalculation = () => ({ type: types.CHEM_RISK_CALCULATION });

export const clearEnvRiskCalculationDto = () => ({ type: types.CLEAR_ENV_RISK_RESULT_DTO });
export const clearChemRiskCalculationDto = () => ({ type: types.CLEAR_CHEM_RISK_RESULT_DTO });

export default {
  calculateChemRiskLevel,
  calculateEnvRisk,
  envRiskCalculation,
  chemRiskCalculation,

  clearEnvRiskCalculationDto,
  clearChemRiskCalculationDto
};
